import type { PostPermissionAssignmentPayload } from '@onhandtech/onhand-fe-shared/lib/contracts/api/common/permission-assignments'
import { createReduxServiceModule } from '@onhandtech/onhand-fe-shared/lib/redux'
import type { RequestArgs } from '@onhandtech/onhand-fe-shared/lib/request'
import { createRequestError } from '@onhandtech/onhand-fe-shared/lib/request'
import type { AxiosError } from 'axios'

export const moduleName = 'delete-request-filter-set-permissions'

const args: RequestArgs<
  null,
  true,
  never,
  PostPermissionAssignmentPayload<'request_filter_set_id'>
> = {
  method: 'DELETE',
  url: '',
  handleSuccess: () => true,
  handleFailure: (error: AxiosError) => createRequestError(error, moduleName),
}

const deleteRequestFilterSetPermissionAssignmentsModule = () =>
  createReduxServiceModule<
    null,
    true,
    never,
    PostPermissionAssignmentPayload<'request_filter_set_id'>
  >({ moduleName, args })

export default deleteRequestFilterSetPermissionAssignmentsModule
